import React, { ChangeEvent } from 'react';
import Input from '../../components/Form/Input';
import { updatePassword } from '../../services/UserService';
import Alert from '../../helpers/Alert';

interface TypeData {
  id: string,
  name: string;
  email: string;
  picture: string;
  branch: string;
  password: string;
}
interface TypeProps {
  data: TypeData;
  setData: Function;
}

export default function GeralConfig({ data, setData }: TypeProps) {

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setData({ ...data, [name]: value });
  };

  const handleSubmit = (event: ChangeEvent<HTMLFormElement>) => {
    event.preventDefault();
    const is_valid = validation();
    is_valid && insertUser();
  };

  const validation = () => {
    const { password } = data;

    // Validações
    if (password.length < 6) {
      Alert(false, 'Senha precisar ter 6 ou mais caracteres');
    } else {
      return true;
    }
  };

  const insertUser = () => {
    const { password } = data
    updatePassword(password)
      .then((res) => {
        Alert(true, 'Perfil atualizado com sucesso! ');
      })
      .catch((err) => {
        Alert(false, err?.data?.message || 'Não foi possível atualizar o seu perfil');
      });
  };
  return (
    <div className='container-box'>
      <h5>Geral</h5>
      <span className='title-describe'>Essas informações irão aparecer no seu perfil.</span>
      <hr />
      <fieldset>
        <form onSubmit={handleSubmit}>

          <div className="row">
            <div className="col-md-6">
              <Input
                name="name"
                label="Nome"
                type="text"
                placeholder={'Digite seu nome'}
                data={data.name}
                setData={handleInputChange}
                disabled={true}
              />
            </div>
            <div className="col-md-6">
              <Input
                name="email"
                label="E-mail"
                type="email"
                placeholder={'email@email.com'}
                data={data.email}
                setData={handleInputChange}
                disabled={true}
              />

            </div>
          </div>
          <Input
            name="password"
            label="Senha"
            type="password"
            placeholder={'Digite uma nova senha'}
            data={data.password}
            setData={handleInputChange}
            required={true}
          />
          <button className='btn btn-primary ' type="submit">Salvar</button>
        </form>

      </fieldset>

    </div>
  )
}
